export enum FindFilterType {
	BeginsWith = 1,
	Equals = 2,
	Contains = 3,
	IdEquals = 4,
}
